import { signOut } from "next-auth/react";
import {
  isWithinLoginGracePeriod,
  markLoginCompleted,
} from "~/lib/auth-grace-period";
import { fetchWrapper } from "~/lib/fetch";

export { markLoginCompleted };

/** Login page shows a notice when this query param is present. */
export const SESSION_EXPIRED_QUERY = "session=expired";

/** Path-only login URL with the session-expired notice (safe for `location.assign`). */
export function loginPathWithSessionExpired(): string {
  return `/login?${SESSION_EXPIRED_QUERY}`;
}

/** Navigate on the current browser origin (avoids NextAuth using the container host). */
export function redirectOnClient(path: string): void {
  if (typeof window === "undefined") return;
  window.location.assign(path);
}

/** Sign out and redirect to login unless we are still in the post-login grace window. */
export function handleUnauthorizedSession(): void {
  if (isWithinLoginGracePeriod()) return;
  void terminateSessionAndRedirectToLogin();
}

/**
 * Clears the app auth cookie, ends the NextAuth session, and sends the user to login.
 * Call when the backend rejects the bearer token (401/403) or verification fails.
 */
export async function terminateSessionAndRedirectToLogin(): Promise<void> {
  try {
    await fetchWrapper("/api/signout?json=1", {
      method: "POST",
      credentials: "include",
    });
  } catch {
    /* still sign out of NextAuth */
  }
  await signOut({ redirect: false });
  redirectOnClient(loginPathWithSessionExpired());
}
